/**
 * Tipos e definições para Analytics
 *
 * Define apenas os tipos essenciais.
 * Catálogos específicos (como tipos de componentes SDUI) devem ser
 * documentados em cada projeto.
 */

/**
 * Schema version - incrementar quando houver mudanças breaking
 */
export const ANALYTICS_SCHEMA_VERSION = 1;

/**
 * Plataforma
 */
export type Platform = 'web' | 'ios' | 'android';

/**
 * Ambiente
 */
export type Environment = 'prod' | 'dev';

/**
 * Parâmetros de contexto que são sempre incluídos em eventos
 */
export interface ContextParams {
  /** Ambiente (prod/dev) */
  env: Environment;
  /** Plataforma */
  platform: Platform;
  /** Versão do schema de eventos */
  schema_version: number;
  /** Nome lógico da tela atual (se disponível) */
  screen?: string;
  /** ID da sessão (se disponível) */
  session_id?: string;
}

/**
 * Parâmetros para evento de impressão de componente SDUI
 *
 * Nota: component_type deve vir de um catálogo finito documentado
 * no projeto (ex: 'venue_card', 'filter_bar', 'hero_banner')
 */
export interface ComponentImpressionParams {
  /** Tipo do componente (usar catálogo finito do projeto) */
  component_type: string;
  /** Chave estável do componente (sem GUIDs voláteis) */
  component_key: string;
  /** Posição do componente (opcional) */
  position?: number;
}
